export interface FormDefinition {
  id: string;
  downloadUrl: string | null;
}

export interface StateLibraryEntry {
  stateCode: string;
  labelKey: string;
  noteKey: string;
  forms: string[];
}

export interface TemplateLibraryEntry {
  id: string;
  path: string;
}

export const FORM_DEFINITIONS: Record<string, FormDefinition> = {
  caDe4: {
    id: 'caDe4',
    downloadUrl: 'https://edd.ca.gov/siteassets/files/pdf_pub_ctr/de-4.pdf',
  },
  nyIt2104: {
    id: 'nyIt2104',
    downloadUrl: 'https://www.tax.ny.gov/pdf/current_forms/it/it2104_fill_in.pdf',
  },
  ilW4: {
    id: 'ilW4',
    downloadUrl: 'https://www2.illinois.gov/rev/forms/withholding/Documents/currentyear/il-w-4.pdf',
  },
  maM4: {
    id: 'maM4',
    downloadUrl: 'https://www.mass.gov/doc/form-m-4-employees-withholding-exemption-certificate/download',
  },
};

export const STATE_FORM_LIBRARY: StateLibraryEntry[] = [
  {
    stateCode: 'CA',
    labelKey: 'forms.states.CA',
    noteKey: 'forms.notes.CA',
    forms: ['caDe4'],
  },
  {
    stateCode: 'NY',
    labelKey: 'forms.states.NY',
    noteKey: 'forms.notes.NY',
    forms: ['nyIt2104'],
  },
  {
    stateCode: 'IL',
    labelKey: 'forms.states.IL',
    noteKey: 'forms.notes.IL',
    forms: ['ilW4'],
  },
  {
    stateCode: 'MA',
    labelKey: 'forms.states.MA',
    noteKey: 'forms.notes.MA',
    forms: ['maM4'],
  },
  {
    stateCode: 'TX',
    labelKey: 'forms.states.TX',
    noteKey: 'forms.notes.none',
    forms: [],
  },
  {
    stateCode: 'FL',
    labelKey: 'forms.states.FL',
    noteKey: 'forms.notes.none',
    forms: [],
  },
];

export const TEMPLATE_LIBRARY: TemplateLibraryEntry[] = [
  {
    id: 'offerLetter',
    path: '/payroll/templates/offer-letter-template.md',
  },
  {
    id: 'handbookAcknowledgement',
    path: '/payroll/templates/handbook-acknowledgement-template.md',
  },
  {
    id: 'directDeposit',
    path: '/payroll/templates/direct-deposit-template.md',
  },
];
